(() => {
  'use strict';

  // Discourage browser save gestures. Publicly displayed images can still be
  // copied with screenshots, browser tools or their public CDN URLs.
  const mediaSelector = 'img, picture, apex-devil, apex-devil-eyes, [data-protected-image]';

  function initialize() {
    if (document.documentElement.dataset.apexSafetyReady === 'true') return;
    document.documentElement.dataset.apexSafetyReady = 'true';

    function protect(element) {
      if (element.matches('img')) element.setAttribute('draggable', 'false');
      if (element.matches('a[target]') && element.target.toLowerCase() === '_blank') {
        element.relList.add('noopener');
      }
    }

    function protectTree(root) {
      if (root.nodeType === 1) protect(root);
      root.querySelectorAll?.('img, a[target]').forEach(protect);
    }

    function mediaTarget(target) {
      if (!(target instanceof Element)) return false;
      if (target.closest(mediaSelector)) return true;
      // Keyboard context menus target the containing link instead of its image.
      const link = target.closest('a');
      return Boolean(link && !link.textContent.trim() && link.querySelector('img'));
    }

    document.addEventListener('contextmenu', event => {
      if (mediaTarget(event.target)) event.preventDefault();
    }, { capture: true });

    document.addEventListener('dragstart', event => {
      const link = event.target instanceof Element ? event.target.closest('a') : null;
      if (mediaTarget(event.target) || link?.querySelector('img')) event.preventDefault();
    }, { capture: true });

    document.addEventListener('click', event => {
      const link = event.target instanceof Element ? event.target.closest('a[target]') : null;
      if (link) protect(link);
    });

    protectTree(document);
    // Garment switches, search suggestions and cart updates insert fresh media.
    new MutationObserver(records => {
      for (const record of records) {
        if (record.type === 'attributes') protect(record.target);
        else for (const node of record.addedNodes) protectTree(node);
      }
    }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['target'] });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();
